import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { ApplyLoanPenaltyFields } from "../../../../data/DynamicForm/FormFields/SuspendedTransactionFormField";
import { loanManagementUrl } from "../../../../config";
import { useNavigate } from "react-router-dom";

const base_url = loanManagementUrl.uri;

const LoanGroupPenaltyApplicationForm = (props) => {
  const navigate = useNavigate()
  const initialValues = {
    id: props.data ? props.data.Id : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        ...values,
      };

      const mutaionDataEditing = {
        loanid: props.data.Id,
        penaltyReason: values.PenaltyReason,
        penaltyAmount: parseFloat(values.PenaltyAmount),
        isgroup: 1
      };

      const response = await executeAnyMutation(
        props.isEditing
          ? "insertLoanPenalty"
          : "createSuspendedTransaction",
        props.isEditing ? mutaionDataEditing : mutationData,
        props.isEditing ? "penaltyApplication" : "suspendedC2B",
        false,
        props.isEditing ? loanManagementUrl.uri : base_url
      );

      if (response.results) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Group Penalty applied successfully.`,
        }).then(() => {
          navigate("/approve-group-penalty"); // 👈 Navigate after alert is closed
        });
      } else if (response.error) {
        throw new Error(response.error);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={ApplyLoanPenaltyFields}
      onSubmit={handleSubmit}
      title={
        props.isEditing ? "Apply Loan Penalty" : "Create Suspended Transaction"
      }
      subtitle={
        props.isEditing
          ? "Apply Loan Penalty"
          : "Create a new Suspended Transaction"
      }
    />
  );
};

export default LoanGroupPenaltyApplicationForm;